import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography, } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ProgressBar from './component/progressBar';
import Openimage from '../../pages/mystery-box/images/open.png';
import Bg from '../../pages/money-fiesta-may/images/links2/bk.jpg';
import Progress from '../../pages/money-fiesta/images/links2/progress bar text.png';
import SHadow from '../../pages/money-fiesta-may/images/links2/image.jpeg';
import Rich from '../../pages/money-fiesta/images/links2/rech.png';
import Clove from '../../pages/money-fiesta/images/links2/strech.png';
import Booking from '../../pages/money-fiesta/images/links2/booking.png';
import Flash from '../../pages/money-fiesta/images/links2/flash.png';
import Card from '../../pages/money-fiesta/images/links2/card.png';
import Faq from '../../pages/money-fiesta/images/links/faqs.png';
import ReactHtmlParser from 'html-react-parser';
import { useNavigate } from 'react-router-dom';
import Clove2 from './images/clove.png'
import Hotels from './images/hotels.png'
import { isValidValue } from '../../utils/function';

function formatDate(dateString) {
  const date = new Date(dateString);
  const options = { day: '2-digit', month: 'long' };
  return date.toLocaleDateString('en-GB', options);
}


const faqs = [
  {
    question: "What is the Free Money Fiesta?",
    answer: "The Free Money Fiesta is a limited time offer where users can set a personalized Cashback target and earn an additional bonus Cashback (Free Money) if they achieve their goal within campaign duration. "
  },
  {
    question: "How do I participate in the campaign?",
    answer: "Simply select your Cashback goal from the available options and start shopping via the CashKaro app or website. "
  },
  {
    question: "Do I need to register separately?",
    answer: "No, there is no separate registration required. Just choose your goal and start shopping!"
  },
  {
    question: "What happens if I achieve my Cashback goal?",
    answer: `If you achieve your selected target within the campaign period, your bonus will be credited within 48 hours. Please note: 
    <ul>
    <li>Referral earnings, special bonuses, Amazon Recharge, and Swiggy orders will not count towards your Cashback goal.</li>
    <li>Only confirmed Cashback/Rewards at the end of the campaign will be considered.</li>
    <li>Your bonus Cashback (Free Money) will be updated by 30th July.</li>
    </ul>
    `
  },
  {
    question: "Can I change my Cashback goal after selecting one?",
    answer: "No, once you select a Cashback goal, it cannot be changed for that campaign period."
  },
  {
    question: "How do I track my progress?",
    answer: "You can track your Cashback progress on the Cashback goal page, where a progress bar will be updated daily."
  },
  {
    question: "Where can I shop to earn Cashback for this campaign?",
    answer: `You can shop from any of your favourite brands listed on CashKaro which offers Cashback, including:
    <ul>
    <li>Flipkart, Amazon, Myntra, Ajio & more</li>
    <li>Flash deals & exclusive offers</li>
    <li>Credit card offers (earn up to ₹2200 Rewards!)</li>
    <li>Biggest sales events</li>
    <li>Referral bonuses, any other special recharges. Amazon Recharges & Swiggy will not be considered.
    </li>
    </ul>`,
  },
  {
    question: "How do I track my progress?",
    answer: "You can track your Cashback progress on the Cashback goal page, where a progress bar will be updated daily."
  },
  {
    question: "When will my bonus Cashback be credited?",
    answer: `Your bonus Cashback will be added to your CashKaro account within 48 hours of meeting the goal &, it will be Confirmed after the campaign ends and once all your transactions are verified. Please Note:
    <ul>
    <li>Referral earnings, special bonuses, Amazon Recharge, and Swiggy orders will not count towards your Cashback goal. </li>
    <li>Only confirmed Cashback/Rewards at the end of the campaign will be considered. </li>
    </ul>`,
  },
  {
    question: "What happens if my order gets cancelled or refunded?",
    answer: "If any of your transactions are cancelled or refunded, they will not count toward your Cashback goal. Your progress bar will be adjusted accordingly."
  },
  {
    question: "Can I participate again in the next campaign?",
    answer: "Yes! If we run another Free Money Fiesta campaign, you will get a new personalized target and can participate again.",
  },
  {
    question: "What happens if I don't meet my Cashback goal?",
    answer: "There's no penalty! You will still receive the Cashback you earned during the campaign, but you won't be eligible for the bonus Cashback."
  },
  {
    question: "Are there any exclusions or limitations?",
    answer: `Yes, here are some key limitations: 
   <ul>
    <li>Transactions must be tracked and approved to count toward your goal. </li>
<li>Fraudulent transactions or multiple accounts created to misuse the offer will not be considered.</li> 
<li>Cashbacks from Cancelled/Retunred-Refuned orders/Referral bonus/Amazon Recharges/Swiggy and any other Transactions won’t count towards your target.</li>
</ul>`, 
  },
  {
    question: "What if I have more questions?",
    answer: "For any additional queries, please click on the Help option in the CashKaro App or Website to connect with our customer support team.",
  }
];

const Terms = [
  {
    question: "What is the Free Money Fiesta?",
    answer: "Free Money Fiesta is a limited-time campaign that allow users to set a personalized Cashback target and earn extra bonus Cashback upon achieving it within the campaign duration."
  },
  {
    question: "What is my target and what do I get after completing it? ",
    answer: "You can select your Cashback goal target that you want to achieve between the campaign's timeline. If you achieve your goal, you will receive bonus Cashback in addition to your earned Cashback. "
  },
  {
    question: "Who can participate? ",
    answer: "Users who are receiving communications and can see the campaign on their app are eligible to participate. It is applicable for Unique Device, Unique User."
  },
  {
    question: "Campaign Duration",
    answer: "Till 31th May"
  },
  {
    question: "How do I get the points?",
    answer: `<ul>
    <li>Shop from your favourite brands</li>
    <li>Shop from Flash Deals</li>
    <li>Apply credit cards and get up to ₹2200 Rewards </li>
    <li>Shop from the biggest sales </li>
    <li>Shop from anywhere on the CashKaro app or website from retailers which offers Cashback on the purchase. Amazon recharges and Swiggy will be excluded.</li>
  </ul>`},
  {
    question: "Benefits",
    answer: "Upon achieving your Cashback milestone, you will receive an additional bonus Cashback. The bonus Cashback (Free Money), will be credited within 48 hours of you achieving your Cashback goal. Please note that referral, any other special bonuses, Amazon recharge and Swiggy will be excluded from the tally of your Cashback goal. In the end of the campaign, only confirmed Cashback/rewards would be considered towards goal achievement. The bonus Cashback (Free Money) will be confirmed by 31st July."
  },
  {
    question: "Do I have to register for the contest?",
    answer: "No separate registration is required. Simply participate by selecting your Cashback goal."
  },
  {
    question: "Exclusions and Limitations",
    answer: `<ul>
    <li>Transactions that are cancelled, refunded, or deemed fraudulent will not be counted toward your Cashback goal.</li>
    <li>Referral, any other special bonuses, Amazon recharges and Swiggy will not be considered.</li>
    <li>The campaign is only valid on eligible purchases made through the CashKaro platform.</li>
    <li>Once users select their Cashback goal, it cannot be reselected or cancelled.</li>
  </ul>`},
  {
    question: "Adjustments and Termination",
    answer: "CashKaro reserves the right to modify or terminate the campaign at any time without prior notice. In case of discrepancies, including transaction cancellations or fraudulent activities, CashKaro reserves the right to adjust scores and rankings. No upward adjustments in rankings will occur due to another participant's score adjustment; rankings may only decrease."
  },
  {
    question: "When is the progress bar updated? ",
    answer: "The progress bar will be updated daily, reflecting tracked transactions from the previous day. Cashback with the extra bonus will be determined based on the total transactions accumulated during the campaign period."
  },
  {
    question: "Declaration by User ",
    answer: "These Terms shall be governed by and construed in accordance with the laws of India. Any disputes arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts of Gurugram, Haryana. By participating in the CashKaro Cashback Goal campaign, you acknowledge that you have read, understood, and agreed to these Terms and Conditions."
  },
];
const style = {
  border: '1px solid transparent',
  marginLeft: '1rem',
  marginRight: '1rem',
  borderImageSource: 'linear-gradient(140.1deg, #525252 -8.09%, #0E0E0E 35.68%)',
  borderImageSlice: 1, // Ensures the gradient is applied to the border
  margin: '0 auto', // Centers the Box horizontally
  background: 'radial-gradient(97.73% 123.25% at 0% 0%, #1F1F1F 0%, #0D0D0D 69.18%)',
  borderRadius: '24px',
  WebkitMaskImage: "linear-gradient(white, white)"
};
const stylee = {
  margin: '0 auto', // Centers the Box horizontally
  background: "#0D0D0D"
}
const options = [
  {
    id: 1,
    title: "Free Money",
    prize: "100",
    description: "Cashback Goal",
    cashback: "2000",
  },
  {
    id: 2,
    title: "Free Money",
    prize: "150",
    description: "Cashback Goal",
    cashback: "2500",
  },
  {
    id: 3,
    title: "Free Money",
    prize: "200",
    description: "Cashback Goal",
    cashback: "3000",
  },
];
export default function MoneyFiestaCongratsMaySegment() {
  const [selected, setSelected] = useState(null);

  const handleSelect = (id) => {
    setSelected(id);

  };
  const [alertOpen, setAlertOpen] = useState(false);
  const [message, setMessage] = useState();
  const [transaction, setTransaction] = useState(0);
  const [Reveal, setReveal] = useState(false);
  const [registered, setRegistered] = useState(false)
  const [showGrid, setShowGrid] = useState(false);
  const user = localStorage.getItem('fiesta_ck_id_may_seg')
  // const mbOpen = localStorage.getItem('mb_open')
  const navigate = useNavigate();
  const [goal, setGoal] = useState(0)
  const [freeMoney, setFreeMoney] = useState(0)
  const [currentCashback, setCurrentCashback] = useState(0)
  const [date, setDate] = useState('')

  const getUserData = async () => {
    if (!isValidValue(user)) {
      navigate('/money-fiesta-may-segment/index')
    }
    try {
      let response = await fetch(`${process.env.REACT_APP_SITE_URL_VP}/api/user/getuserdata_fmf_may?ck_id=${user}`)
      response = await response.json()
      // console.log(response)
      if (response?.user_data?.current_cashback >= response?.user_data?.selected_cashback_goal) {
        navigate("/money-fiesta-may-segment/bonus")
      }
      setGoal(response?.user_data?.selected_cashback_goal)
      setFreeMoney(response?.user_data?.selected_free_money)
      setCurrentCashback(response?.user_data?.current_cashback)
      setDate(formatDate(response?.user_data?.updatedAt))
    } catch (error) {
      console.log(error.message)
    }
  }

  useEffect(() => {
    getUserData()
  }, [])


  return (
    <Grid container >
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}
        sx={{
          backgroundImage: `url(${Bg})`, backgroundSize: 'cover', backgroundPosition: 'top',
        }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
          <img src={Progress} alt='Progress' style={{ width: '60%' }} />
        </div>
        <Typography mt={1} sx={{ color: '#fff', fontSize: '0.75rem', textAlign: 'center', fontFamily: 'Metropolis' }}>Updated as on {date}</Typography>

        <ProgressBar current={currentCashback} goal={goal} />


        <div>
          <img src={SHadow} alt='SHadow' style={{ width: '100%' }} />
        </div>
        <Grid sx={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: "center", marginTop: '-26%' }}>
          <div style={{ marginTop: '-6%', width: "40%" }}>
            <div>
              {/* <svg viewBox="0 0 30 9" xmlns="http://www.w3.org/2000/svg">
                <path id="MyPath" fill="none" stroke="none" d="M 0 5 Q 15 -2 30 5" pathLength="2" />

                <text font-size="3px" font-family="Metropolis" font-weight="bold" dominant-baseline="hanging" text-anchor="middle" fill="white">
                  <textPath href="#MyPath" startOffset="1">
                    Your Cashback Goal
                  </textPath>
                </text>
              </svg> */}
              <Typography sx={{ fontSize: "10px", fontWeight: "bold", textAlign: "center", color: "#fff" }}>Your Cashback Goal</Typography>

            </div>

            <div style={{}}>
              <Typography sx={{ fontSize: "24px", fontWeight: "bold", textAlign: "center", color: "#fff" }}>  ₹{goal}</Typography>
              {/* <svg viewBox="0 0 30 9" xmlns="http://www.w3.org/2000/svg">
              <path id="MyPath" fill="none" stroke="none" d="M 0 5 Q 15 -2 30 5" pathLength="2" />
              <text font-size="8px" font-weight="bold" dominant-baseline="hanging" text-anchor="middle" fill="white">
                <textPath href="#MyPath" startOffset="1">
                  ₹{goal}
                </textPath>
              </text>
            </svg> */}
            </div>
          </div>
          <div style={{ marginTop: '-6%', width: "40%" }}>
            <div>
              {/* <svg viewBox="0 0 30 9" xmlns="http://www.w3.org/2000/svg">
                <path id="MyPath" fill="none" stroke="none" d="M 0 5 Q 15 -2 30 5" pathLength="2" />

                <text font-size="3px" font-weight="bold" dominant-baseline="hanging" text-anchor="middle" fill="white">
                  <textPath href="#MyPath" startOffset="1">
                    Free Money
                  </textPath>
                </text>
              </svg> */}
              <Typography sx={{ fontSize: "10px", fontWeight: "bold", textAlign: "center", color: "#fff" }}>Free Money</Typography>
            </div>

            <div style={{}}>
              <Typography sx={{ fontSize: "24px", fontWeight: "bold", textAlign: "center", color: "#fff" }}>  ₹{freeMoney}</Typography>
              {/* <svg viewBox="0 0 30 9" xmlns="http://www.w3.org/2000/svg">
              <path id="MyPath" fill="none" stroke="none" d="M 0 5 Q 15 -2 30 5" pathLength="2" />
              <text font-size="8px" font-weight="bold" dominant-baseline="hanging" text-anchor="middle" fill="white">
                <textPath href="#MyPath" startOffset="1">
                  ₹{freeMoney}
                </textPath>
              </text>
            </svg> */}
            </div>
          </div>
        </Grid>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '25%' }}>
          <img src={Rich} alt='Rich' style={{ width: '60%' }} />
        </div>
        <div style={{ paddingLeft: '4rem', paddingRight: '4rem', marginTop: '1rem' }}>
          <Typography sx={{ color: '#fff', fontSize: '0.75rem', textAlign: 'center', fontFamily: 'Metropolis' }}>Save big on every transaction done on the offers below</Typography>
        </div>



        <div style={{ marginTop: '1rem', paddingLeft: '1rem', paddingRight: '1rem' }}>
          <a href='cashkaro://top-selling-products/best-finance-deals'>
            <img src={Card} alt='card' style={{ width: '100%' }} />
          </a>
        </div>
        <div style={{ marginTop: '1rem', paddingLeft: '1rem', paddingRight: '1rem' }}>
          <a href='cashkaro://top-selling-products/flash-deals'>
            <img src={Flash} alt='flash' style={{ width: '100%' }} />
          </a>
        </div>
        <div style={{ marginTop: '1rem', paddingLeft: '1rem', paddingRight: '1rem' }}>
          <a href='cashkaro://stores/booking'>
            <img src={Hotels} alt='booking' style={{ width: '100%' }} />
          </a>
        </div>
        <div style={{ marginTop: '1rem', paddingLeft: '1.7rem', paddingRight: '1.7rem', paddingBottom: '1rem', display: 'flex', justifyContent: 'center', }}>
          <a href='cashkaro://stores/clove-oral-care-coupons'>
            <img src={Clove2} alt='clove' style={{ width: '100%' }} />
          </a>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '4rem' }}>
          <img src={Faq} alt='faq' style={{ width: '30%' }} />
        </div>
        <Box sx={{ paddingX: '18px', marginTop: '3rem' }}>
          {faqs.map((faq, i) => (
            <Box
              sx={{
                marginBottom: "16px",
                padding: "2px",
                background:
                  "transparent",
                borderRadius: "14px",
              }}
            >
              <Accordion
                sx={{
                  borderRadius: "14px !important",
                  background: "transparent",
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: 600,
                  fontFamily: 'Metropolis',
                  boxShadow: 'none'
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                  sx={{ color: '#fce100', }}>
                  {faq?.question}
                </AccordionSummary>
                <AccordionDetails>{ReactHtmlParser(faq?.answer)}</AccordionDetails>
              </Accordion>
            </Box>))}
        </Box>
        <Box sx={{ paddingX: '18px' }} pb={16}>
          <Typography sx={{ textAlign: 'center', paddingTop: '16px', fontFamily: "DM Sans", marginBottom: '16px', color: '#fff', fontSize: '12px', fontWeight: 600, lineHeight: '16px', letterSpacing: '3px' }}>TERMS & CONDITIONS</Typography>
          {Terms.map((Terms, i) => (
            <Box
              sx={{
                marginBottom: "16px",
                padding: "2px",
                borderRadius: "14px",
                background:
                  "transparent",
              }}
            >
              <Accordion
                sx={{
                  borderRadius: "14px !important",
                  color: "#fff",
                  fontSize: "14px",
                  background:
                    "transparent",
                  boxShadow: 'none',
                  fontWeight: 600,
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                  sx={{ color: '#fce100', }}>
                  {Terms?.question}
                </AccordionSummary>
                <AccordionDetails>{ReactHtmlParser(Terms?.answer)}</AccordionDetails>
              </Accordion>
            </Box>))}
        </Box>
      </Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>

    </Grid>
  );
}
